.mapContainer {
  height: calc(100vh - 50px);
  overflow-y: hidden;
  width: 65vw;
  display: flex;
}
